import React from "react";
import "./style/MeetingHistory.css";
import { Box, Typography } from "@mui/material"
import CardMeetingHistory from "./CardMeetingHistory";
import { callApi } from "../../common/api";
import Backdrop from '@mui/material/Backdrop';
import Modal from '@mui/material/Modal';
import RescheduleMeetingReason from "./RescheduleMeetingReason";
import ScheduleMeeting from "../Layout/ScheduleMeeting";
import Loader from "../../common/components/Loader"
import TablePagination from '@mui/material/TablePagination';
import CustomizedSnackbars from "../alert/alert";

const MeetingHistory = () => {
    const [reason, setReason] = React.useState("");
    const [data, setData] = React.useState([]);
    const [next, setNext] = React.useState(false)
    const [status, setStatus] = React.useState("");
    const [id, setId] = React.useState("");
    const [startupId, setStartupId] = React.useState("");
    const [open, setOpen] = React.useState(false);
    const [total, setTotal] = React.useState(0)
    const [count, setCount] = React.useState(0)
    const [success, setSuccess] = React.useState(false);
    const [res, setRes] = React.useState(false)
    const [start, setStart] = React.useState(1);
    const [snackBarMsg, setSnackBarMsg] = React.useState({
        message: "",
        severity: "success",
        open: false,
      });
    const [end, setEnd] = React.useState(0)
    const [writeReview, setWriteReview] = React.useState(1)
    const [meetingId , setMeetingId] = React.useState("")
    const[statusChange, setStatusChange] = React.useState(false)
    const handleOpen = (status, id, startUpId, meetingId) => {
        setMeetingId(meetingId)
        setId(id)
        setStatus(status)
        setOpen(true);
        setRes(false);
        setStartupId(startUpId)
        if (status === "CANCELLED") {
            setNext(true)
        }
    }
    const handleCancel = (id) => {
        setOpen(true);
        setRes(true)
        setId(id)
    }
    const reviews = async () => {
        if (writeReview) { }
    }
    const cancelMeeting = async () => {
        if (reason) {
            let obj = {
                reason: reason,
                meetingId: id
            }
            try {
                const response = await callApi("post", "meeting/cancel", obj);
                if(response.status){
                    setSnackBarMsg({
                        message:"Meeting Cancelled Successfully",
                        severity:"success",
                        open:true
                    })
                    setStatusChange(!statusChange)
                    setTimeout(() => {
                       setOpen(false)
                    }, 1000)
                }
            } catch (error) {
                console.log(error)
            }
        }
    }

    const handleChangePage = (event, newPage) => {
        setCount(newPage);
    };
    const handleClose = () => {
        setReason("")
        setNext(false)
        setOpen(false);
    }

    const handleNext = () => {
        if (reason) {
            setNext(true)
        }
    }
    const handleChange = (event) => {
        const value = event.target.value;
        setReason(value)
    }

    const handlePage = (opr) => {
        if (opr === "plus" && end !== total) {
            setCount(count + 1)
            setStart(end + 1)
        } else if (opr === "minus" && count > 1) {
            setCount(count - 1)
        }
    }
    const getMeetingHistory = async () => {
        const response = await callApi("get", `meeting/getdata?page=${count}`)
        setSuccess(response.data.response.status)
        setTotal(response.data.response.data.user.count)
        setData(response.data.response.data.user.rows);
        setEnd((prevState) => prevState + response.data.response.data.user.rows.length)
    }
    React.useEffect(() => {
        getMeetingHistory()
    }, [count, statusChange])

    return (
        <>
            <Modal
                aria-labelledby="transition-modal-title"
                aria-describedby="transition-modal-description"
                open={open}
                onClose={handleClose}
                closeAfterTransition
                slots={{ backdrop: Backdrop }}
                slotProps={{
                    backdrop: {
                        timeout: 500,
                    },
                }}
            >
                {next ?
                    <ScheduleMeeting
                        statusChange={statusChange}
                        setStatusChange={setStatusChange}
                        startupId={startupId}
                        reshceduleReason={reason}
                        meetingId={meetingId}
                        id={id}
                        meetingStatus={status}
                        handleClose={handleClose}
                    /> :
                    <RescheduleMeetingReason
                        handleClose={handleClose}
                        handleNext={handleNext}
                        handleChange={handleChange}
                        res={res}
                        cancelMeeting={cancelMeeting}
                        review={1}

                    />}

            </Modal>
            <Box id="meeting-history">
                <Box className="heading-box">
                    <Typography className="heading" variant="h5">Meeting History</Typography>
                </Box>
                <Box className="card-box">
                    {!success ? <Box sx={{ alignSelf: "stretch", position: "relative" }}><Loader /></Box> : (
                        <>
                            {data.length === 0 ?
                                <Box sx={{ alignSelf: "stretch", textAlign: "center" }}>
                                    <Typography variant="h5" sx={{ color: "white" }}>
                                        No meeting scheduled till now
                                    </Typography>
                                </Box>
                                :
                                data.map((d, i) =>
                                    <CardMeetingHistory
                                        key={i}
                                        status={d.status}
                                        meeting={d}
                                        OpenReschedule={handleOpen}
                                        handleCancel={handleCancel}
                                    />)
                            }

                        </>
                    )}
                </Box>
                {!data || data.length === 0 ? <></> :
                    // <Box className="meeting-history-footer">
                    //     <Typography className="next-click"><ArrowBackIosIcon sx={{ fontSize: "8px " }} /><button onClick={() => handlePage("minus")}>Previous</button></Typography>
                    //     <Typography className="show-page">Showing {start}-{end} of {total}</Typography>
                    //     <Typography className="next-click"><button onClick={() => handlePage("plus")}>Next</button> <ArrowForwardIosIcon sx={{ fontSize: "8px " }} /></Typography>
                    // </Box>
                    <TablePagination
                        sx={{
                            alignSelf: 'center', color: "white", alignItems: 'baseline', '& .MuiTablePagination-toolbar': {
                                alignItems: "baseline"
                            }
                        }}
                        component="div"
                        count={total}
                        page={count}
                        onPageChange={handleChangePage}
                        rowsPerPage={5}
                        rowsPerPageOptions={[]}
                        nextIconButtonProps={{ sx: { color: 'white' } }}
                        backIconButtonProps={{ sx: { color: 'white' } }}



                    />
                }
            </Box>
            <CustomizedSnackbars msgData={snackBarMsg} setMsgData={setSnackBarMsg} />
        </>
    )
}
export default MeetingHistory;
